import { Component, OnInit, Input, Injector, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonDataModel } from '../common-data-model';
import { CommonService } from 'src/app-core/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-order-participants-configuation',
  templateUrl: './account-order-participants-configuation.component.html',
  styleUrls: ['./account-order-participants-configuation.component.scss']
})
export class AccountOrderParticipantsConfiguationComponent implements OnInit, OnDestroy {

  @Input() set accountPariticipantsParams(accountPariticipantsParams: any) {
    if (accountPariticipantsParams && accountPariticipantsParams.accountId) {
      this.accountParticipantsConfigurationData.accountId = accountPariticipantsParams.accountId;
      this.accountParticipantsConfigurationData.isParticipantsConfigure = accountPariticipantsParams.isParticipantsConfigure;
    }
  }

  componentSubscriptions: Subscription = new Subscription();
  commonDataModel = new CommonDataModel();
  isFormLoading = false;
  accountParticipantsConfigurationData: any;

  constructor(
    injector: Injector,
    private commonService: CommonService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.accountParticipantsConfigurationData = this.commonDataModel.acconutParticipantsCondifurationModel;
  }

  onChangeStatus() {
    this.commonService.getConfirmationPopup
      (`You want to ${this.accountParticipantsConfigurationData.isParticipantsConfigure ? 'Activate' : 'De-active'} Job/Quote participants.`,
      'Cancel', 'Confirm').then(result => {
        if (result) {
          this.isFormLoading = true;
          this.commonService.updateAccountIsParticipantsConfigure(this.accountParticipantsConfigurationData).subscribe((response: any) => {
            this.isFormLoading = false;
            this.accountParticipantsConfigurationData.isParticipantsConfigure = response.data.isParticipantsConfigure;
            if (response.isSuccess) {
              this.toastr.success(response.errors);
            } else {
              this.toastr.error(response.errors, 'Error!');
            }
          });
        } else {
          this.accountParticipantsConfigurationData.isParticipantsConfigure = !this.accountParticipantsConfigurationData.isParticipantsConfigure;
        }
      });
  }

  ngOnDestroy(): void {
    this.componentSubscriptions.unsubscribe();
  }
}
